
<div [formGroup]="form">
  <div class="row">
    <div class="form-group col-6" >
      <custom-select
        [filterEnabled]="true"
        [labelText]="'Tipo de archivo'"
        [bordered]="true"
        name="fileType"
        id="fileType"
        formControlName="fileType"
        [(sourceList)]="_fileTypeList"
        (select)="onSelectFileType()"
        required>
      </custom-select>
    </div>
    <div class="form-group col-6 pl-0" >
      <label for="myFile">Archivo</label>
      <div class="input-group">
        <div class="custom-file">
          <input name="myFile" id="myFile" type="file" [accept]="_accepFileTye" (change)="onFileChange($event)" #file formControlName="fileModel" [disabled]="fileModels.length">
          <label class="custom-file-label" for="myFile">{{ _appService.CoreCommonLiterals.SelectFile }}</label>
        </div>
        <div class="input-group-append" style="z-index: 0;">
          <button type="button" class="btn btn-primary" id="add-file" (click)="file.click()" [disabled]="fileModels.length">{{_appService.CoreCommonLiterals.Browse}}</button>
        </div>
      </div>
    </div>
    <div class="col-12" *ngFor="let selected of fileModels; let i = index">
      <div class="card w-100 p-3 d-flex mt-2 justify-content-between" style="border-radius: 0.25rem;" *ngIf="selected.file64" >
        <label for="image" class="text-truncate">Previsualización 
          <span ><strong>&nbsp; {{selected.fileName}}</strong></span>
        </label>
        <figure *ngIf="selected.file64" class="card no-shadow border" style="max-width: 370px;">
          <div class="card-body p-2">
            <img *ngIf="selected.fileType === 'image'" [src]="(selected.file64) ? sanitizer.bypassSecurityTrustResourceUrl(selected.file64): null" width="100%" id="fileImage">
            <div *ngIf="selected.fileType === 'audio'">
              <audio controls preload="auto" style="width: 100%;"><source [src]="(selected.file64)" type="audio/mp4" /></audio>
            </div>
            <div *ngIf="selected.fileType === 'documento' || selected.fileType === 'pdf' || selected.fileType === 'excel' || selected.fileType === 'unknown'" class="d-flex justify-content-center align-items-center" style="min-height: 200px;">
              <i *ngIf="selected.fileType === 'documento'" class="fa-solid fa-file-lines fa-2xl" style="font-size: 10rem; color: var(--primary);"></i>
              <i *ngIf="selected.fileType === 'pdf'" class="fa-solid fa-file-pdf fa-2xl" style="font-size: 10rem; color: var(--primary);"></i>
              <!-- <i *ngIf="selected.fileType === 'excel'" class="fa-solid fa-file-excel fa-2xl" style="font-size: 10rem; color: var(--primary);"></i> -->
              <i *ngIf="selected.fileType === 'unknown'" class="fa-solid fa-file fa-2xl" style="font-size: 10rem; color: var(--primary);"></i>
              <iframe *ngIf="selected.fileType === 'excel'"  [src]="sanitizer.bypassSecurityTrustResourceUrl('https://view.officeapps.live.com/op/embed.aspx?src=' + selected.file64)" width="100%" height="600px"></iframe>
            </div>
            <div *ngIf="selected.fileType === 'video'" class="d-flex justify-content-center align-items-center" >
              <video width="250" controls>
                <source [src]="sanitizer.bypassSecurityTrustResourceUrl(selected?.file64)" type="video/mp4">
              </video>
            </div>
            <button id="image-btn-delete" type="button" class="btn btn-danger btn-block mt-2" (click)="deleteImage(i)" *ngIf="!editing">
              {{_appService.CoreCommonLiterals.Delete}}
            </button>
          </div>
        </figure>
        <div class="form-group col mt-2 px-0" [ngClass]="{'col-12': selected.file64}" *ngIf="selected.file64">
          <label for="fileDescription">Descripción</label>
          <textarea
            type="text" 
            customFocus 
            maxlength="500"
            name="fileDescription"
            [rows]="2"
            formControlName="fileDescription"
            class="form-control" 
            id="fileDescription" 
            [placeholder]="'Descripción'"
          ></textarea>
        </div>
      </div>
    </div>
  </div>
</div>
